import LocationGroupRepository from './LocationGroupRepository'

export default class BulkAddLocationGroupFormModel {
  constructor({ ownerProfileId }) {
    this.ownerProfileId = ownerProfileId
    this.body = ''
    this.accessibleType = 'public' // 固定
  }

  get parsedLocationGroups() {
    return this.body
      .trim()
      .split(/\n/)
      .filter(name => name.trim().length > 0)
  }

  async save() {
    const locationGroupOrErrors = await Promise.all(
      this.parsedLocationGroups
        .map(name => {
          return {
            ownerProfileId: this.ownerProfileId,
            name,
            accessibleType: this.accessibleType,
          }
        })
        .map(createLocationGroup),
    )
    const errors = locationGroupOrErrors.filter(obj => obj instanceof Error)

    if (errors.length > 0) {
      const error = new Error(
        `一部登録できなかった地点があります。\n入力欄をご確認ください。`,
      )
      error.errors = errors
      throw error
    } else {
      return locationGroupOrErrors.filter(obj => !(obj instanceof Error))
    }
  }
}

const createLocationGroup = async locationGroup => {
  try {
    return await LocationGroupRepository.create(locationGroup)
  } catch (e) {
    e.locationGroup = locationGroup
    return e
  }
}
